
{
  "familyId": "STU-DIAGRAM",
  "questions": [
    {
      "id": "STU-DIAGRAM-001",
      "familyId": "STU-DIAGRAM",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_diagram",
      "questionType": "multiple_choice",
      "question": "In een staafdiagram staan de maanden op de x-as en het aantal regenbuien op de y-as. De staaf van juni is 12 hoog en die van juli is 8 hoog. Hoeveel meer regenbuien waren er in juni dan in juli?",
      "options": ["4", "12", "20", "8"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Staafdiagram aflezen",
            "content": "Bij een staafdiagram lees je de hoogte van elke staaf af op de y-as. Het verschil bereken je door de waarden van elkaar af te trekken: 12 − 8 = 4.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "diagram_staaf_verschil",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Lees de hoogte van de staven af: juni = 12, juli = 8. Het verschil is 12 − 8 = 4 regenbuien.",
        "solutionSteps": [
          "Lees de staaf van juni af: 12 regenbuien",
          "Lees de staaf van juli af: 8 regenbuien",
          "Bereken het verschil: 12 − 8 = 4"
        ],
        "distractorExplanations": {
          "0": "Goed! 12 − 8 = 4 meer regenbuien in juni.",
          "1": "12 is het aantal regenbuien in juni, niet het verschil. Je moet aftrekken: 12 − 8 = 4.",
          "2": "20 is de som (12 + 8), niet het verschil. De vraag is hoeveel MEER, dus je trekt af.",
          "3": "8 is het aantal regenbuien in juli, niet het verschil."
        }
      }
    },
    {
      "id": "STU-DIAGRAM-002",
      "familyId": "STU-DIAGRAM",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_diagram",
      "questionType": "multiple_choice",
      "question": "In een cirkeldiagram over favoriete sport is het deel 'voetbal' precies een kwart van de cirkel. Er deden 120 leerlingen mee aan de enquête. Hoeveel kozen voetbal?",
      "options": ["30", "40", "25", "60"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Cirkeldiagram aflezen",
            "content": "Een kwart van de cirkel = ¼ = 25%. Om het aantal te berekenen: totaal × ¼ = 120 × ¼ = 30.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "diagram_cirkel_kwart",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Een kwart van de cirkel = ¼ van het totaal. ¼ × 120 = 30 leerlingen kozen voetbal.",
        "solutionSteps": [
          "Een kwart = ¼ = 25%",
          "¼ × 120 = 120 ÷ 4 = 30",
          "30 leerlingen kozen voetbal"
        ],
        "distractorExplanations": {
          "0": "Goed! ¼ × 120 = 30 leerlingen.",
          "1": "40 zou kloppen als het ⅓ was (120 ÷ 3 = 40), maar het is ¼.",
          "2": "25 is het percentage (25%), niet het aantal leerlingen. 25% van 120 = 30.",
          "3": "60 is de helft van 120. Een kwart is ¼, niet ½."
        }
      }
    },
    {
      "id": "STU-DIAGRAM-003",
      "familyId": "STU-DIAGRAM",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_diagram",
      "questionType": "multiple_choice",
      "question": "Welk type diagram gebruik je het best om te laten zien hoe de temperatuur verandert over een hele week?",
      "options": ["Lijndiagram", "Cirkeldiagram", "Staafdiagram", "Pictogram"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Welk diagram waarvoor?",
            "content": "Lijndiagram = verandering over tijd. Staafdiagram = hoeveelheden vergelijken. Cirkeldiagram = delen van een geheel. Pictogram = eenvoudige aantallen met plaatjes.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "diagram_type_kiezen",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Een lijndiagram is het beste voor veranderingen over tijd. De lijn laat zien of de temperatuur stijgt, daalt of gelijk blijft. Een staafdiagram is beter voor het vergelijken van losse hoeveelheden.",
        "solutionSteps": [
          "Verandering over tijd → lijndiagram",
          "De lijn toont stijging en daling",
          "Staaf = vergelijken, cirkel = delen van geheel"
        ],
        "distractorExplanations": {
          "0": "Goed! Een lijndiagram toont veranderingen over tijd het duidelijkst.",
          "1": "Een cirkeldiagram toont delen van een geheel (bijv. 30% regen, 70% zon). Het is niet geschikt voor veranderingen over tijd.",
          "2": "Een staafdiagram vergelijkt losse hoeveelheden. Het kan, maar een lijndiagram toont de trend (stijging/daling) veel duidelijker.",
          "3": "Een pictogram gebruikt plaatjes om aantallen te tonen. Het is te simpel voor temperatuurveranderingen over een week."
        }
      }
    },
    {
      "id": "STU-DIAGRAM-004",
      "familyId": "STU-DIAGRAM",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_diagram",
      "questionType": "multiple_choice",
      "question": "In een lijndiagram daalt de lijn steil tussen woensdag en donderdag. Wat betekent dat?",
      "options": ["De waarde is snel gedaald", "De waarde is gelijk gebleven", "De waarde is langzaam gestegen", "Er zijn geen gegevens voor die dag"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Lijndiagram interpreteren",
            "content": "Steil omlaag = snelle daling. Steil omhoog = snelle stijging. Vlak = weinig verandering. Horizontaal = gelijk gebleven.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "diagram_lijn_trend",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Een steile daling in een lijndiagram betekent dat de waarde snel is gedaald. Hoe steiler de lijn naar beneden gaat, hoe sneller de verandering.",
        "solutionSteps": [
          "De lijn gaat steil naar beneden",
          "Steil = snelle verandering",
          "Naar beneden = daling",
          "Dus: de waarde is snel gedaald"
        ],
        "distractorExplanations": {
          "0": "Goed! Een steile daling betekent dat de waarde snel is afgenomen.",
          "1": "Als de waarde gelijk was gebleven, zou de lijn horizontaal (vlak) zijn.",
          "2": "Langzaam gestegen zou een lijn zijn die langzaam omhoog gaat, niet steil omlaag.",
          "3": "Als er geen gegevens waren, zou er een onderbreking in de lijn zijn, niet een steile daling."
        }
      }
    },
    {
      "id": "STU-DIAGRAM-005",
      "familyId": "STU-DIAGRAM",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_diagram",
      "questionType": "matching",
      "question": "Koppel elk diagramtype aan het beste gebruik.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "Lijndiagram", "right": "Verandering over tijd" },
          { "left": "Staafdiagram", "right": "Hoeveelheden vergelijken" },
          { "left": "Cirkeldiagram", "right": "Delen van een geheel" },
          { "left": "Pictogram", "right": "Aantallen met plaatjes" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Diagramtypes",
            "content": "Lijn = tijd/trend. Staaf = vergelijken. Cirkel = delen/procenten. Pictogram = eenvoudige aantallen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "diagram_types_match",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Lijndiagram → verandering over tijd. Staafdiagram → hoeveelheden vergelijken. Cirkeldiagram → delen van een geheel. Pictogram → aantallen met plaatjes.",
        "solutionSteps": [
          "Lijndiagram → verandering over tijd (trend)",
          "Staafdiagram → hoeveelheden vergelijken",
          "Cirkeldiagram → delen van een geheel (procenten)",
          "Pictogram → aantallen met plaatjes"
        ]
      }
    }
  ]
}
